import React from "react";
import { useSnapshot } from "valtio";

import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { store } from "../../store";

import { ImageDisplay } from "../../../../Common/ImageDisplay";

export function Section1Preview({ deviceType, section }: any): JSX.Element {
    const sectionData = templateActions.getNestedObject([
        "template",
        "SiteWeb",
        "LaindingPage",
        section,
    ]);

    const getActiveImages = () => {
        if (!sectionData) return [];
        return Object.entries(sectionData)
            .filter(([key]) => key.startsWith("Image"))
            .map(([key, value]: [string, any]) => value[deviceType])
            .slice(0, 3);
    };

    const activeScreens = getActiveImages();
    const { selectedLanguage } = useSnapshot(store);

    const title = sectionData?.Title?.[selectedLanguage] || "";

    return (
        <div
            style={{
                height: "100vh",
                overflowY: "auto",
                scrollbarWidth: "none",
                borderLeft: "1px #c6c7c9 solid",
                padding: "50px",
                paddingBottom: "250px",
                boxSizing: "border-box",
            }}
        >
            {activeScreens.length > 0 && (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            padding: "1rem",
                        }}
                    >
                        <h1
                            style={{
                                fontSize: "2rem",
                                fontWeight: "bold",
                                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                                margin: 0,
                            }}
                        >
                            {title}
                        </h1>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            gap: "20px",
                            justifyContent: "center",
                        }}
                    >
                        {activeScreens
                            .slice(0, 2)
                            .map((item: any, index: number) => (
                                <ImageDisplay
                                    key={item.id}
                                    item={item}
                                    width={index === 0 ? "60%" : "38%"}
                                    height="350px"
                                />
                            ))}
                    </div>

                    {activeScreens.length > 2 && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <ImageDisplay
                                item={activeScreens[2]}
                                width="100%"
                                height="250px"
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
